import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger, Form } from 'react-bootstrap';
import { Icon } from '@storable/canaveral-components';
import { compose, pure } from 'utils/react';
import cx from 'classnames';
import styles from './styles.scss';

const SingleRadio = ({
  label,
  input = {},
  value,
  meta, // eslint-disable-line no-unused-vars
  tooltip,
  ...props
}) => {
  const tooltipComponent = tooltip && (
    <Tooltip id={`tooltip-${value}`}>
      {tooltip}
    </Tooltip>
  );

  // const { radioOptionsClass } = props;

  return (
    <div className={styles.radioContainer}>
      <Form.Check
        {...input}
        {...props}
        type="radio"
        value={value}
        checked={input && input.value === value}
        label={
          <span className={cx({ [styles.label]: tooltip })}>
            {label}
          </span>
        }
        id={`radio-${value}`}
        className={cx({ [styles.radio]: tooltip })}
      />
      {tooltip && (
        <OverlayTrigger placement="top" overlay={tooltipComponent}>
          <span>
            <Icon id="tool-tip" label="tooltip" className={styles.tooltip} />
          </span>
        </OverlayTrigger>
      )}

    </div>
  );
};

SingleRadio.propTypes = {
  label: PropTypes.string.isRequired,
  input: PropTypes.object,
  meta: PropTypes.object,
  tooltip: PropTypes.string,
  value: PropTypes.any,
};

const Radio = ({
  options,
  tooltips = {},
  radioImages = {},
  parentStyle = {},
  ...props
}) => (
  <div className={parentStyle}>
    {Object.keys(options).map((value, index) => (
      <div key={index}>
        {radioImages && radioImages[value] && (
          <img
            className={styles.radioButtonImageStyle}
            src={radioImages[value].imgSrc}
            alt={radioImages[value].imgAlt}
          />
        )}
        <SingleRadio
          {...props}
          value={value}
          label={options[value]}
          tooltip={tooltips[value]}
          className={styles.radioButton}
        />
      </div>
    ))}
  </div>
);

Radio.propTypes = {
  options: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default compose(
  pure(),
)(Radio);
